import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
import SidebarMenuItem from './SidebarMenuItem';
import NavLink from './NavLink';
import './DropdownMenuItem.css';

const DropdownMenuItem = ({ 
    icon, 
    title, 
    defaultRoute, 
    children, 
    isCollapsed = false,
    className = '' 
}) => {
    const navigate = useNavigate();
    const [isExpanded, setIsExpanded] = useState(false);

    const handleToggle = () => {
        if (!isExpanded && defaultRoute) {
            // При розгортанні переходимо на дефолтний роут
            navigate(defaultRoute);
        }
        setIsExpanded(!isExpanded);
    };

    return (
        <>
            {/* Main menu item */}
            <div onClick={handleToggle} className={`dropdown-menu-item ${className}`}>
                <SidebarMenuItem icon={icon}>
                    {!isCollapsed && (
                        <span className="dropdown-content">
                            <span>{title}</span>
                            <span className="chevron-icon">
                                {isExpanded ? <FaChevronDown /> : <FaChevronRight />}
                            </span>
                        </span>
                    )}
                    {isCollapsed && title}
                </SidebarMenuItem>
            </div>
            
            {/* Submenu */}
            {isExpanded && children && (
                <div className={isCollapsed ? "" : "dropdown-submenu"}>
                    {children}
                </div>
            )}
        </>
    );
};

// Компонент для елементів підменю
export const DropdownSubMenuItem = ({ to, icon, children, className = '' }) => {
    return (
        <NavLink to={to}>
            <SidebarMenuItem icon={icon} className={`submenu-item ${className}`}>
                {children}
            </SidebarMenuItem>
        </NavLink>
    );
};

export default DropdownMenuItem;
